// ui/stimulus.js
import { Application } from '@hotwired/stimulus'

import staffWebJsControllers from '../../../packs/staff_web/app/components/**/*_controller.js'
import staffWebTsControllers from '../../../packs/staff_web/app/components/**/*_controller.ts'
import uiJsControllers from '../../../packs/ui/app/components/ui/**/*_controller.js'
import uiTsControllers from '../../../packs/ui/app/components/ui/**/*_controller.ts'
import UnloadingRemarksAdjustmentsController from '../src/v3/controllers/unloading_remarks_adjustments_controller'

// Infer Stimulus controller names from its file paths
function staffWebControllerName(defaultName) {
  // "..--..--..--..--packs--staff_web--app--components--staff_web---trucking-job-route-box" ->
  // "sw-trucking-job-route-box"
  const parts = defaultName.split('--')
  return `sw-${parts[parts.length - 1]}`
}

function uiControllerName(defaultName) {
  // "..--..--..--..--packs--ui--app--components--ui---structural--top-jump-search--top-jump-search-mobile-trigger" ->
  // "ui-top-jump-search-mobile-trigger"
  const parts = defaultName.split('--')
  return `ui-${parts[parts.length - 1]}`
}

export default {
  start() {
    const staffWebControllers = [...staffWebJsControllers, ...staffWebTsControllers]
    const uiControllers = [...uiJsControllers, ...uiTsControllers]

    const application = Application.start()
    window.Stimulus = application

    staffWebControllers.forEach(controller => {
      application.register(staffWebControllerName(controller.name), controller.module.default)
    })

    uiControllers.forEach(controller => {
      application.register(uiControllerName(controller.name), controller.module.default)
    })

    application.register('sw-unloading-remarks-adjustments', UnloadingRemarksAdjustmentsController)
  }
}
